import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { configureQuery, LayoutComponentNames, createLayoutComponentObject } from '@diana/core';
import { useGetComponentDefaultPropertiesBySchema } from './useGetComponentDefaultPropertiesBySchema';

export const useCreateEmptySection = () => {
  const schemaQuery = configureQuery.getComponentSchema({
    schemaName: LayoutComponentNames.SECTION,
  });

  const { data: schema } = useQuery({
    queryKey: schemaQuery.key,
    queryFn: schemaQuery.fn,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  const getComponentDefaultPropertiesBySchema = useGetComponentDefaultPropertiesBySchema();

  const defaultSectionProperties = useMemo(
    () => getComponentDefaultPropertiesBySchema(schema),
    [getComponentDefaultPropertiesBySchema, schema],
  );

  return useCallback(() => {
    return createLayoutComponentObject({
      component: LayoutComponentNames.SECTION,
      label: '',
      dataPathUpdate: 'Auto',
      properties: {
        width: 'col-12',
        ...defaultSectionProperties,
      },
    });
  }, [defaultSectionProperties]);
};
